import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import IItem from "../../models/item";
import { useDispatch } from "react-redux";
//MaterialUI
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CardMedia from "@material-ui/core/CardMedia";

import DeleteIcon from "@material-ui/icons/Delete";
import Icon from "@material-ui/core/Icon";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import { deleteItem, getAllItems } from "../redux/slices/item/itemSlice";
import ProductTable from "../products/ProductTable";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export default function ItemDetail() {
  const { slug } = useParams<any>();
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllItems());
  }, [dispatch]);

  const Items: IItem[] = useSelector((state) => state.item.data);

  const filteredArray = Items.filter((item) => item.slug === slug);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(deleteItem(slug));
  };

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}> </div>
      <div className="{classes.heroContent}">
        {filteredArray.map((filteredItem: IItem) => (
          <>
            <Container key={filteredItem.id} maxWidth="sm">
              <Typography
                component="h1"
                variant="h2"
                align="center"
                color="textPrimary"
                gutterBottom
              >
                {filteredItem.name}
              </Typography>{" "}
              <CardMedia
                image={filteredItem.item_image}
                title="Image title"
                component="img"
              />
              <Button
                variant="contained"
                color="primary"
                className="{classes.button}"
                endIcon={<Icon>send</Icon>}
              >
                Start assembly
              </Button>
              <Link
                to={
                  `/department/production-dashboard/product-list/product/` +
                  slug +
                  `/edit`
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  className="{classes.button}"
                  startIcon={<DeleteIcon />}
                >
                  Edit product
                </Button>
              </Link>
              <Button
                variant="contained"
                color="primary"
                className="{classes.button}"
                startIcon={<DeleteIcon />}
                onClick={handleSubmit}
              >
                Delete product
              </Button>
              <Button
                variant="contained"
                color="primary"
                className="{classes.button}"
                startIcon={<FolderOpenIcon />}
              >
                Drawings
              </Button>
            </Container>
            {console.log(filteredItem.product)}
            <ProductTable props={filteredItem.product} />
          </>
        ))}
      </div>
    </Container>
  );
}
